import { jsx as i, jsxs as N } from "react/jsx-runtime";
import { forwardRef as L, useState as _, useRef as S, useMemo as I, useCallback as G, useId as U, cloneElement as pe, useEffect as H } from "react";
import { c } from "./tw-cn-mXgPecoF.mjs";
import { R as W } from "./rectangle-button-7EcaVrM8.mjs";
import { I as ye } from "./ic_close-BJ5TqFBV.mjs";
import { t as he } from "./throttle-CbOTDqvg.mjs";
import { o as ge } from "./index-CcECYkhV.mjs";
import { I as ve } from "./icon-button-UFwDzoPr.mjs";
import { c as f } from "./index-BpNK5r1N.mjs";
import { u as M } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { createPortal as Ce } from "react-dom";
const we = f(["w-screen h-screen fixed left-0 top-0 bg-scrim"], {
  variants: {
    show: {
      true: "animate-dimFadeIn",
      false: "animate-dimFadeOut"
    }
  }
}), X = L(
  ({ show: r = !0, zMax: t, onClick: m = () => {
  }, onAnimationEnd: n = () => {
  }, children: o }, e) => {
    const [a, g] = _(!1), p = we({
      show: r
    });
    return M(() => {
      g(!1);
    }, [r]), !r && a ? null : (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- dim layer click
      /* @__PURE__ */ i(
        "div",
        {
          className: c(p, t ? "z-max" : ""),
          onAnimationEnd: () => {
            g(!0), n();
          },
          onClick: m,
          ref: e,
          children: o
        }
      )
    );
  }
);
X.displayName = "NDS.DimLayer";
const xe = ({ show: r, mode: t }) => {
  M(() => {
    if (!r) return;
    window.ya__ || (window.ya__ = { dialogCount: 0 });
    const m = window.ya__.dialogCount ?? 0;
    if (window.ya__.dialogCount = m + 1, t === "fixed") {
      const [n, o, e] = [document.body.style.position, window.scrollY, window.scrollX];
      return document.body.style.position = "fixed", document.body.style.top = `-${o}px`, document.body.style.left = `-${e}px`, () => {
        window.ya__ || (window.ya__ = { dialogCount: 0 }), window.ya__.dialogCount--, window.ya__.dialogCount <= 0 && (document.body.style.position = n, window.scroll({ top: o, left: e }));
      };
    }
    return document.body.style.overflow = "hidden", () => {
      window.ya__ || (window.ya__ = { dialogCount: 0 }), window.ya__.dialogCount--, window.ya__.dialogCount <= 0 && (document.body.style.overflow = "unset");
    };
  }, [t, r]);
}, q = "_ROOT_NDS_MODAL_", be = ({ id: r, children: t, show: m, zIndex: n = 1, containerClassName: o = "" }) => {
  const e = S(null), [a, g] = _(null), p = I(() => a ? Ce(t, a) : null, [t, a]), v = G(() => {
    var s;
    (s = a == null ? void 0 : a.parentElement) == null || s.removeChild(a);
  }, [a]), y = G(() => {
    e.current = document.getElementById(q), e.current || (e.current = document.createElement("div"), e.current.id = q, e.current.style.position = "relative", e.current.style.zIndex = `${n}`, o && (e.current.className = o), document.body.appendChild(e.current));
    const s = `modal-${r}`;
    let d = document.getElementById(s);
    return d || (d = document.createElement("div"), d.id = s, e.current.appendChild(d)), d;
  }, [r]);
  return M(() => {
    if (!m) return;
    const s = y(), d = document.createElement("div");
    return g(d), s.appendChild(d), () => {
      d.addEventListener("animationend", () => {
        var C, w;
        (C = d.parentElement) == null || C.removeChild(d), (w = s.parentElement) == null || w.removeChild(s);
      });
    };
  }, [m, y]), {
    portal: p,
    modalElement: a,
    clearModalElement: v
  };
}, B = (r) => {
  const t = U(), { id: m, mode: n = "overflow", show: o = !0, zIndex: e, containerClassName: a, children: g } = r, p = I(() => m ?? t, [m, t]);
  xe({ show: o, mode: n });
  const v = g ? pe(g, {
    id: p,
    mode: n
  }) : null, { portal: y, clearModalElement: s } = be({
    id: p,
    show: o,
    zIndex: e,
    containerClassName: a,
    children: /* @__PURE__ */ i(
      X,
      {
        id: p,
        mode: n,
        onAnimationEnd: () => {
          !o && s();
        },
        onClick: r.onBackdropClick,
        show: o,
        children: v ?? void 0
      }
    )
  });
  return y;
};
B.displayName = "NDS.Modal";
const V = f([
  "fixed mx-auto left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-h-screen min-h-88"
]), _e = f(
  ["inline-flex flex-col align-center justify-center bg-static-white rounded-12 p-16 pt-32 w-[29.6rem]"],
  {
    variants: {
      active: {
        true: "animate-dialogScaleDown",
        false: "animate-dialogScaleUp"
      }
    }
  }
), Se = f(["inline-flex flex-col items-center justify-center"]), Ne = f([
  "typography-subtitle-16-bold text-text-neutral-main select-none text-center whitespace-pre-line"
]), Ee = f(["inline-flex flex-col items-center justify-center "]), De = f([
  "mt-12 typography-body-14-regular text-text-neutral-sub select-none text-center whitespace-pre-line"
]), Ie = f([
  "inline-flex typography-body-14-bold flex-row items-stretch justify-center gap-8 mt-24"
]), He = L(
  ({
    id: r,
    show: t,
    title: m,
    description: n,
    positiveButton: o,
    negativeButton: e,
    zIndex: a,
    onAnimationEnd: g,
    mode: p,
    onBackdropClick: v,
    containerClassName: y
  }, s) => {
    const d = V({}), C = _e({ active: t }), w = Se({}), T = Ne({}), R = Ee({}), k = De({}), z = Ie({}), x = S(null), E = S(null);
    H(() => {
      let l;
      return t && (E.current = document.activeElement, l = requestAnimationFrame(() => {
        var u;
        (u = x.current) == null || u.focus();
      })), () => {
        var u;
        l && cancelAnimationFrame(l), t || (u = E.current) == null || u.focus();
      };
    }, [t]), H(() => {
      var l;
      return t && ((l = document.getElementById("__next")) == null || l.setAttribute("aria-hidden", "true")), () => {
        var u;
        (u = document.getElementById("__next")) == null || u.removeAttribute("aria-hidden");
      };
    }, [t]);
    const D = ({ title: l, text: u }) => l ?? (typeof u == "string" ? u : void 0);
    return /* @__PURE__ */ i(
      B,
      {
        containerClassName: y,
        id: r,
        mode: p,
        onBackdropClick: v,
        show: t,
        zIndex: a,
        children: /* @__PURE__ */ i(
          "div",
          {
            className: c(d),
            onClick: (l) => {
              l.stopPropagation();
            },
            ref: s,
            children: /* @__PURE__ */ N("div", { className: c(C), onAnimationEnd: g, children: [
              /* @__PURE__ */ i("div", { className: c(w), children: /* @__PURE__ */ i("span", { className: c(T), style: { overflowWrap: "anywhere" }, children: m }) }),
              !!n && /* @__PURE__ */ i("div", { className: c(R), children: /* @__PURE__ */ i("span", { className: c(k), children: n }) }),
              /* @__PURE__ */ N("div", { className: c(z), children: [
                !!e && /* @__PURE__ */ i(
                  W,
                  {
                    fullWidth: !0,
                    onClick: e.onClick,
                    size: "medium",
                    theme: "outlined_basic",
                    title: D(e),
                    weight: "bold",
                    children: e.text
                  }
                ),
                /* @__PURE__ */ i(
                  W,
                  {
                    fullWidth: !0,
                    onClick: o.onClick,
                    ref: x,
                    size: "medium",
                    theme: "outlined_secondary",
                    title: D(o),
                    weight: "bold",
                    children: o.text
                  }
                )
              ] })
            ] })
          }
        )
      }
    );
  }
);
He.displayName = "NDS.Dialog";
const Te = f(
  ["inline-flex overflow-auto flex-col bg-static-white rounded-28 py-24 shadow-3"],
  {
    variants: {
      size: {
        medium: "w-[40rem]",
        large: "w-[60rem]"
      },
      active: {
        true: "animate-dialogScaleDown",
        false: "animate-dialogScaleUp"
      }
    }
  }
), Re = f([
  "pl-32 pr-20 pb-4 flex items-start justify-between gap-16 self-stretch"
]), ke = f(["my-8 text-text-neutral-main select-none"], {
  variants: {
    titleType: {
      action: "typography-subtitle-20-bold truncate",
      highlight: "typography-subtitle-20-bold line-clamp-2",
      noPadding: ""
    }
  },
  defaultVariants: {
    titleType: "action"
  }
}), ze = f(["flex items-center justify-center size-40 p-4 cursor-pointer"]), Ae = f("overflow-auto relative h-full", {
  variants: {
    bodyType: {
      default: "px-32",
      noPadding: ""
    }
  }
}), Pe = f("w-full shrink-0", {
  variants: {
    footerType: {
      default: "px-32 pt-12",
      noPadding: ""
    }
  }
}), Fe = 48, Le = L((r, t) => {
  var O, $;
  const {
    id: m,
    show: n,
    title: o,
    titleType: e = "action",
    body: a,
    bodyType: g = "default",
    footer: p,
    footerType: v = "default",
    height: y = "contents",
    noCloseIcon: s = !1,
    className: d,
    onAnimationEnd: C,
    onClose: w,
    mode: T,
    zIndex: R,
    bottomSheetBodyRef: k,
    size: z = "medium",
    onScroll: x,
    hasBottomGradation: E = !0,
    onBackdropClick: D
  } = r, l = S(null), u = S(null), A = S(null), j = U(), [Y, J] = _(!1), [K, Q] = _(!1), [Z, ee] = _(0), [te, ne] = _(0), oe = I(() => m ?? j, [m, j]), ie = V(), ae = Te({
    active: n,
    size: z
  }), le = Re(), re = ze(), ce = ke({ titleType: e }), se = Ae({ bodyType: g }), de = Pe({ footerType: v }), ue = I(() => y === "contents" ? "auto" : y === "full" ? "100%" : y, [y]), P = he(() => {
    if (l.current) {
      const { scrollTop: h, scrollHeight: b, clientHeight: F } = l.current, fe = h + F >= b;
      Q(!fe);
    }
  }, 100), me = (h) => {
    P(), x == null || x(h);
  };
  return H(() => {
    const h = () => {
      if (l.current) {
        const { scrollHeight: b, clientHeight: F } = l.current;
        J(b > F);
      }
    };
    if (n)
      return P(), h(), window.addEventListener("resize", h), () => {
        window.removeEventListener("resize", h);
      };
  }, [n, l.current, y]), H(() => {
    var h, b;
    n && (P(), ne(((h = A.current) == null ? void 0 : h.clientHeight) ?? 0), ee(((b = u.current) == null ? void 0 : b.clientHeight) ?? 0));
  }, [n, (O = A.current) == null ? void 0 : O.clientHeight, ($ = u.current) == null ? void 0 : $.clientHeight]), /* @__PURE__ */ i(B, { id: oe, mode: T, onBackdropClick: D, show: n, zIndex: R, children: /* @__PURE__ */ i(
    "div",
    {
      className: c(ie, "flex"),
      onClick: (h) => {
        h.stopPropagation();
      },
      ref: t,
      style: {
        maxHeight: "calc(100vh - 200px)",
        height: ue,
        minHeight: `${te + Z + Fe}px`
      },
      children: /* @__PURE__ */ N("div", { className: c(ae, d), onAnimationEnd: C, children: [
        /* @__PURE__ */ i("div", { ref: A, children: e === "noPadding" ? o : /* @__PURE__ */ N("div", { className: c(le), children: [
          /* @__PURE__ */ i("span", { className: c(ce), children: o }),
          !s && /* @__PURE__ */ i(
            ve,
            {
              className: c(re),
              icon: /* @__PURE__ */ i(ye, { className: "size-24" }),
              onClick: w,
              size: "medium",
              theme: "ghost"
            }
          )
        ] }) }),
        !!a && /* @__PURE__ */ N("div", { className: "relative h-full overflow-y-auto", children: [
          /* @__PURE__ */ i(
            "div",
            {
              className: c(se),
              onScroll: me,
              ref: ge([l, k]),
              children: a
            }
          ),
          Y && E ? /* @__PURE__ */ i(
            "div",
            {
              className: c(
                "pointer-events-none absolute inset-x-0 bottom-0 z-50 h-80 px-32 opacity-0 transition-opacity duration-500",
                {
                  "opacity-100": K
                }
              ),
              style: {
                background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 82.36%)"
              }
            }
          ) : null
        ] }),
        !!p && /* @__PURE__ */ i("div", { className: c(de), ref: u, children: p })
      ] })
    }
  ) });
});
Le.displayName = "NDS.PcDialogSheet";
export {
  X as D,
  Le as P,
  He as a,
  xe as u
};
